// extracted by mini-css-extract-plugin
module.exports = {"root":"_99551c8aa8--root--meiu_","fullfiled":"_99551c8aa8--fullfiled--oh3kr"};